import { render, staticRenderFns } from "./moveKnowledgeForm.vue?vue&type=template&id=6267cb41&scoped=true&"
import script from "./moveKnowledgeForm.vue?vue&type=script&lang=js&"
export * from "./moveKnowledgeForm.vue?vue&type=script&lang=js&"
import style0 from "./moveKnowledgeForm.vue?vue&type=style&index=0&id=6267cb41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6267cb41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6267cb41')) {
      api.createRecord('6267cb41', component.options)
    } else {
      api.reload('6267cb41', component.options)
    }
    module.hot.accept("./moveKnowledgeForm.vue?vue&type=template&id=6267cb41&scoped=true&", function () {
      api.rerender('6267cb41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledgeBaseMgr/knowledgeMgr/components/moveKnowledgeForm.vue"
export default component.exports